export interface GeoAddressRequest {
    identifier?: string;
    latitude?: number;
    longitude?: number;
  }
  